import React from "react";
import { Container, Grid, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { Twitter, Instagram } from "@mui/icons-material";
import YouTubeIcon from "@mui/icons-material/YouTube";
import StayInformed from "../utils/StayInformed";

const scrollTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

export default function Footer() {
  return (
    <div className="footer">
      {/* Stay Informed card — sits above dark section, white bg context */}
      <div style={{ backgroundColor: "#fff", paddingBottom: "0" }}>
        <StayInformed />
      </div>

      {/* Dark footer section */}
      <div className="footer-start">
        <Container maxWidth="lg">
          <Grid container spacing={6} sx={{ pt: 8, pb: 6 }}>

            {/* Col 1 — Brand */}
            <Grid item xs={12} md={4}>
              <img src="/RX-Pose-white.svg" alt="RXpose logo" style={{ height: "40px", marginBottom: "20px" }} />
              <Typography variant="body2" className="description" sx={{ lineHeight: 1.8, maxWidth: "320px" }}>
                RXpose is a non-profit initiative dedicated to making U.S.
                prescription drug price information more transparent and
                accessible to the public.
              </Typography>
            </Grid>

            {/* Col 2 — Navigation */}
            <Grid item xs={6} md={4}>
              <Typography variant="h6" className="footer_title heading_four" gutterBottom>
                Navigation
              </Typography>
              <nav className="footer_nav_link">
                <Link onClick={scrollTop} to="/">Home</Link>
                <Link onClick={scrollTop} to="/medicines">Browse Medications</Link>
                <Link onClick={scrollTop} to="/contact-congressman">Contact Congressman</Link>
                <Link onClick={scrollTop} to="/healthcare">Healthcare in America</Link>
                <Link onClick={scrollTop} to="/contact">Contact Us</Link>
              </nav>
            </Grid>

            {/* Col 3 — About */}
            <Grid item xs={6} md={4}>
              <Typography variant="h6" className="footer_title heading_four" gutterBottom>
                About
              </Typography>
              <nav className="footer_nav_link">
                <Link onClick={scrollTop} to="/">About RXpose</Link>
                <Link onClick={scrollTop} to="/healthcare">Why Drug Prices Are High</Link>
                <Link onClick={scrollTop} to="/contact-congressman">Take Action</Link>
                <Link onClick={scrollTop} to="/contact">Get In Touch</Link>
              </nav>
            </Grid>

          </Grid>

          {/* Divider */}
          <div style={{ borderTop: "0.5px solid #ebf8f23b" }} />

          {/* Bottom bar */}
          <Grid container justifyContent="space-between" alignItems="center" sx={{ py: 3 }}>
            <Grid item xs={12} sm={6}>
              <Typography variant="body2" className="description">
                © Copyright {new Date().getFullYear()} RXpose. All rights reserved.
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Grid container alignItems="center" justifyContent={{ xs: "flex-start", sm: "flex-end" }} gap="16px" className="social_media" sx={{ mt: { xs: 2, sm: 0 } }}>
                <a href="#" aria-label="Facebook" style={{ display: "flex", alignItems: "center", justifyContent: "center", width: 32, height: 32, borderRadius: "50%", backgroundColor: "var(--Dark-Gray)" }}>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" style={{ width: 15, height: 15 }}><path d="M80 299.3V512H196V299.3h86.5l18-97.8H196V166.9c0-51.7 20.3-71.5 72.7-71.5c16.3 0 29.4 .4 37 1.2V7.9C291.4 4 256.4 0 236.2 0C129.3 0 80 50.5 80 159.4v42.1H14v97.8H80z" /></svg>
                </a>
                <a href="#" aria-label="Twitter" style={{ display: "flex", alignItems: "center", justifyContent: "center", width: 32, height: 32, borderRadius: "50%", backgroundColor: "var(--Dark-Gray)" }}>
                  <Twitter sx={{ width: 15, height: 15, color: "var(--Dark)" }} />
                </a>
                <a href="#" aria-label="Instagram" style={{ display: "flex", alignItems: "center", justifyContent: "center", width: 32, height: 32, borderRadius: "50%", backgroundColor: "var(--Dark-Gray)" }}>
                  <Instagram sx={{ width: 15, height: 15, color: "var(--Dark)" }} />
                </a>
                <a href="#" aria-label="YouTube" style={{ display: "flex", alignItems: "center", justifyContent: "center", width: 32, height: 32, borderRadius: "50%", backgroundColor: "var(--Dark-Gray)" }}>
                  <YouTubeIcon sx={{ width: 15, height: 15, color: "var(--Dark)" }} />
                </a>
              </Grid>
            </Grid>
          </Grid>

        </Container>
      </div>
    </div>
  );
}
